const getAppliedValues = options => {
  const values = Array.isArray(options) ? options : [];

  return values.filter(value => (value.applied && value.isActive === 'true'));
};

export default getAppliedValues;
